import React from "react";
import {
  MetadataContainer,
  MetadataItem,
  MetadataLabel,
  MetadataValue,
} from "./LogMetadata.styles";

export const LogMetadata = ({ logData, t }) => {
  if (!logData) return null;

  return (
    <MetadataContainer>
      <MetadataItem>
        <MetadataLabel>{t("logs.model")}:</MetadataLabel>
        <MetadataValue>
          {logData.model || t("common.notAvailable")}
        </MetadataValue>
      </MetadataItem>

      <MetadataItem>
        <MetadataLabel>{t("logs.totalTokens")}:</MetadataLabel>
        <MetadataValue>
          {logData.total_tokens || t("common.notAvailable")}
        </MetadataValue>
      </MetadataItem>

      {logData.prompt_tokens && (
        <MetadataItem>
          <MetadataLabel>{t("logs.promptTokens")}:</MetadataLabel>
          <MetadataValue>{logData.prompt_tokens}</MetadataValue>
        </MetadataItem>
      )}

      {logData.completion_tokens && (
        <MetadataItem>
          <MetadataLabel>{t("logs.completionTokens")}:</MetadataLabel>
          <MetadataValue>{logData.completion_tokens}</MetadataValue>
        </MetadataItem>
      )}

      <MetadataItem>
        <MetadataLabel>{t("logs.cost")}:</MetadataLabel>
        <MetadataValue>
          {logData.total_price || t("common.notAvailable")}
        </MetadataValue>
      </MetadataItem>

      {logData.request_timestamp && (
        <MetadataItem>
          <MetadataLabel>{t("logs.date")}:</MetadataLabel>
          <MetadataValue>
            {new Date(logData.request_timestamp).toLocaleString()}
          </MetadataValue>
        </MetadataItem>
      )}
    </MetadataContainer>
  );
};
